/* shop/OrderEbookDownloader.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	init,
	insert_dev,
	listen_dev,
	noop,
	run_all,
	safe_not_equal,
	set_data_dev,
	set_input_value,
	space,
	text,
	validate_each_argument,
	validate_slots
} from "svelte/internal";

const file = "shop/OrderEbookDownloader.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (62:0) {#if display_state == DISPLAY_STATES.LOCKED}
function create_if_block_4(ctx) {
	let h1;
	let t1;
	let label;
	let t3;
	let input;
	let t4;
	let button;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			h1 = element("h1");
			h1.textContent = "Váš ebook ke stažení";
			t1 = space();
			label = element("label");
			label.textContent = "Zde prosím zadejte váš kod zaslaný emailem:";
			t3 = space();
			input = element("input");
			t4 = space();
			button = element("button");
			button.textContent = "Odemknout stažení eknih";
			add_location(h1, file, 63, 4, 1420);
			attr_dev(label, "class", "labelCenter");
			attr_dev(label, "for", "code_for_order");
			add_location(label, file, 64, 4, 1454);
			attr_dev(input, "id", "code_for_order");
			attr_dev(input, "type", "password");
			attr_dev(input, "class", "basketInputCode");
			attr_dev(input, "placeholder", "Váš kód z emailu");
			add_location(input, file, 66, 4, 1561);
			attr_dev(button, "class", "basketButton");
			attr_dev(button, "type", "button");
			add_location(button, file, 73, 4, 1730);
		},
		m: function mount(target, anchor) {
			insert_dev(target, h1, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, label, anchor);
			insert_dev(target, t3, anchor);
			insert_dev(target, input, anchor);
			set_input_value(input, /*password*/ ctx[0]);
			insert_dev(target, t4, anchor);
			insert_dev(target, button, anchor);

			if (!mounted) {
				dispose = [
					listen_dev(input, "input", /*input_input_handler*/ ctx[5]),
					listen_dev(button, "click", /*click_handler*/ ctx[6], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty & /*password*/ 1 && input.value !== /*password*/ ctx[0]) {
				set_input_value(input, /*password*/ ctx[0]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(h1);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(label);
			if (detaching) detach_dev(t3);
			if (detaching) detach_dev(input);
			if (detaching) detach_dev(t4);
			if (detaching) detach_dev(button);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(62:0) {#if display_state == DISPLAY_STATES.LOCKED}",
		ctx
	});

	return block;
}

// (81:0) {#if display_state == DISPLAY_STATES.UNLOCKED}
function create_if_block(ctx) {
	let each_1_anchor;
	let each_value = /*ebooks*/ ctx[1];
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const block = {
		c: function create() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m: function mount(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(target, anchor);
				}
			}

			insert_dev(target, each_1_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*ebooks*/ 2) {
				each_value = /*ebooks*/ ctx[1];
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d: function destroy(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach_dev(each_1_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(81:0) {#if display_state == DISPLAY_STATES.UNLOCKED}",
		ctx
	});

	return block;
}

// (89:16) {#if ebook.ebook_pdf}
function create_if_block_3(ctx) {
	let li;
	let a;
	let t;
	let a_href_value;

	const block = {
		c: function create() {
			li = element("li");
			a = element("a");
			t = text("PDF");
			attr_dev(a, "href", a_href_value = /*ebook*/ ctx[9].ebook_pdf);
			attr_dev(a, "class", "btn-link-left");
			attr_dev(a, "target", "_blank");
			add_location(a, file, 90, 24, 2245);
			add_location(li, file, 89, 20, 2216);
		},
		m: function mount(target, anchor) {
			insert_dev(target, li, anchor);
			append_dev(li, a);
			append_dev(a, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*ebooks*/ 2 && a_href_value !== (a_href_value = /*ebook*/ ctx[9].ebook_pdf)) {
				attr_dev(a, "href", a_href_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(li);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(89:16) {#if ebook.ebook_pdf}",
		ctx
	});

	return block;
}

// (95:16) {#if ebook.ebook_epub}
function create_if_block_2(ctx) {
	let li;
	let a;
	let t;
	let a_href_value;

	const block = {
		c: function create() {
			li = element("li");
			a = element("a");
			t = text("EPUB");
			attr_dev(a, "href", a_href_value = /*ebook*/ ctx[9].ebook_epub);
			attr_dev(a, "class", "btn-link-left");
			attr_dev(a, "target", "_blank");
			add_location(a, file, 96, 24, 2456);
			add_location(li, file, 95, 20, 2427);
		},
		m: function mount(target, anchor) {
			insert_dev(target, li, anchor);
			append_dev(li, a);
			append_dev(a, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*ebooks*/ 2 && a_href_value !== (a_href_value = /*ebook*/ ctx[9].ebook_epub)) {
				attr_dev(a, "href", a_href_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(li);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(95:16) {#if ebook.ebook_epub}",
		ctx
	});

	return block;
}

// (101:16) {#if ebook.ebook_mobi}
function create_if_block_1(ctx) {
	let li;
	let a;
	let t;
	let a_href_value;

	const block = {
		c: function create() {
			li = element("li");
			a = element("a");
			t = text("MOBI");
			attr_dev(a, "href", a_href_value = /*ebook*/ ctx[9].ebook_mobi);
			attr_dev(a, "class", "btn-link-left");
			attr_dev(a, "target", "_blank");
			add_location(a, file, 102, 24, 2669);
			add_location(li, file, 101, 20, 2640);
		},
		m: function mount(target, anchor) {
			insert_dev(target, li, anchor);
			append_dev(li, a);
			append_dev(a, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*ebooks*/ 2 && a_href_value !== (a_href_value = /*ebook*/ ctx[9].ebook_mobi)) {
				attr_dev(a, "href", a_href_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(li);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(101:16) {#if ebook.ebook_mobi}",
		ctx
	});

	return block;
}

// (82:4) {#each ebooks as ebook}
function create_each_block(ctx) {
	let div;
	let h2;
	let t1;
	let h1;
	let t2_value = /*ebook*/ ctx[9].title + "";
	let t2;
	let t3;
	let br;
	let t4;
	let p;
	let t6;
	let ul;
	let t7;
	let t8;
	let t9;
	let if_block0 = /*ebook*/ ctx[9].ebook_pdf && create_if_block_3(ctx);
	let if_block1 = /*ebook*/ ctx[9].ebook_epub && create_if_block_2(ctx);
	let if_block2 = /*ebook*/ ctx[9].ebook_mobi && create_if_block_1(ctx);

	const block = {
		c: function create() {
			div = element("div");
			h2 = element("h2");
			h2.textContent = "Portál pro stažení:";
			t1 = space();
			h1 = element("h1");
			t2 = text(t2_value);
			t3 = space();
			br = element("br");
			t4 = space();
			p = element("p");
			p.textContent = "Formáty ke stažení:";
			t6 = space();
			ul = element("ul");
			if (if_block0) if_block0.c();
			t7 = space();
			if (if_block1) if_block1.c();
			t8 = space();
			if (if_block2) if_block2.c();
			t9 = space();
			add_location(h2, file, 83, 12, 1979);
			add_location(h1, file, 84, 12, 2020);
			add_location(br, file, 85, 12, 2055);
			add_location(p, file, 86, 12, 2073);
			attr_dev(ul, "class", "order__list tabs__content__links");
			add_location(ul, file, 87, 12, 2112);
			add_location(div, file, 82, 8, 1961);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, h2);
			append_dev(div, t1);
			append_dev(div, h1);
			append_dev(h1, t2);
			append_dev(div, t3);
			append_dev(div, br);
			append_dev(div, t4);
			append_dev(div, p);
			append_dev(div, t6);
			append_dev(div, ul);
			if (if_block0) if_block0.m(ul, null);
			append_dev(ul, t7);
			if (if_block1) if_block1.m(ul, null);
			append_dev(ul, t8);
			if (if_block2) if_block2.m(ul, null);
			append_dev(div, t9);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*ebooks*/ 2 && t2_value !== (t2_value = /*ebook*/ ctx[9].title + "")) set_data_dev(t2, t2_value);

			if (/*ebook*/ ctx[9].ebook_pdf) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(ul, t7);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*ebook*/ ctx[9].ebook_epub) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(ul, t8);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*ebook*/ ctx[9].ebook_mobi) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_1(ctx);
					if_block2.c();
					if_block2.m(ul, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(82:4) {#each ebooks as ebook}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div;
	let t;
	let if_block0 = /*display_state*/ ctx[2] == /*DISPLAY_STATES*/ ctx[3].LOCKED && create_if_block_4(ctx);
	let if_block1 = /*display_state*/ ctx[2] == /*DISPLAY_STATES*/ ctx[3].UNLOCKED && create_if_block(ctx);

	const block = {
		c: function create() {
			div = element("div");
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			attr_dev(div, "class", "container basket order");
			add_location(div, file, 59, 0, 1332);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append_dev(div, t);
			if (if_block1) if_block1.m(div, null);
		},
		p: function update(ctx, [dirty]) {
			if (/*display_state*/ ctx[2] == /*DISPLAY_STATES*/ ctx[3].LOCKED) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					if_block0.m(div, t);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*display_state*/ ctx[2] == /*DISPLAY_STATES*/ ctx[3].UNLOCKED) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('OrderEbookDownloader', slots, []);
	const dataElm = document.getElementById("orderEbookDownloader");
	const orderId = dataElm.dataset.order;

	// password
	let password = "";

	// ebooks
	let ebooks = [];

	// stav zobrazeni
	const DISPLAY_STATES = { LOCKED: "LOCKED", UNLOCKED: "UNLOCKED" };

	let display_state = DISPLAY_STATES.LOCKED;

	// odeslani hesla
	const handleUnlockDownload = () => {
		const ERROR_MESSAGE = 'Pravděpodobně jste zadal/a chybné heslo.';
		const URL = "/api/shop/order/" + orderId + "/ebook-items/" + password;
		const xhr = new XMLHttpRequest();
		xhr.open("GET", URL, true);

		// chyba pri odeslani
		xhr.addEventListener("error", () => {
			alert(ERROR_MESSAGE);
		});

		// zpracovani response
		xhr.addEventListener("load", () => {
			// v poradku
			if (xhr.status == 200) {
				$$invalidate(2, display_state = DISPLAY_STATES.UNLOCKED);
				$$invalidate(1, ebooks = JSON.parse(xhr.responseText).ebooks);
			} else {
				alert(ERROR_MESSAGE); // chyba
			}
		});

		// odeslani pozadavku
		xhr.send();
	};

	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<OrderEbookDownloader> was created with unknown prop '${key}'`);
	});

	function input_input_handler() {
		password = this.value;
		$$invalidate(0, password);
	}

	const click_handler = () => handleUnlockDownload();

	$$self.$capture_state = () => ({
		dataElm,
		orderId,
		password,
		ebooks,
		DISPLAY_STATES,
		display_state,
		handleUnlockDownload
	});

	$$self.$inject_state = $$props => {
		if ('password' in $$props) $$invalidate(0, password = $$props.password);
		if ('ebooks' in $$props) $$invalidate(1, ebooks = $$props.ebooks);
		if ('display_state' in $$props) $$invalidate(2, display_state = $$props.display_state);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [
		password,
		ebooks,
		display_state,
		DISPLAY_STATES,
		handleUnlockDownload,
		input_input_handler,
		click_handler
	];
}

class OrderEbookDownloader extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "OrderEbookDownloader",
			options,
			id: create_fragment.name
		});
	}
}

export default OrderEbookDownloader;